module.exports = new __parcel__URL__("BrickVideoStudio.56cd45ed.avif").toString();